import { ByTitlePage } from './ByTitlePage'
import { withByTitlePage } from './withByTitlePage'

const ConnectedByTitlePage = withByTitlePage(ByTitlePage)

export { ConnectedByTitlePage as ByTitlePage }
